import { useTranslation } from 'react-i18next'

interface Props {
  potentialCoins?: number  // task.reward_per_item_coins (FOUND reward)
  submissionType?: 'found' | 'not_found'
}

const CONFETTI = [
  { color: '#6366f1', left: '20%', delay: '0ms' },
  { color: '#a855f7', left: '35%', delay: '80ms' },
  { color: '#f59e0b', left: '50%', delay: '40ms' },
  { color: '#22c55e', left: '65%', delay: '120ms' },
  { color: '#3b82f6', left: '80%', delay: '20ms' },
  { color: '#ec4899', left: '12%', delay: '100ms' },
]

export default function SuccessOverlay({ potentialCoins, submissionType = 'found' }: Props) {
  const { t } = useTranslation('worker')

  // For not_found, coins are half
  const displayCoins =
    potentialCoins != null
      ? submissionType === 'not_found'
        ? Math.floor(potentialCoins / 2)
        : potentialCoins
      : null

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center"
      style={{ background: 'rgba(0,0,0,0.55)' }}
    >
      {/* Confetti dots */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {CONFETTI.map((c, i) => (
          <div
            key={i}
            className="absolute bottom-1/2 w-3 h-3 rounded-full anim-confetti"
            style={{
              background: c.color,
              left: c.left,
              animationDelay: c.delay,
            }}
          />
        ))}
      </div>

      {/* Check circle */}
      <div
        className="w-24 h-24 rounded-full flex items-center justify-center anim-scale-in"
        style={{ background: '#22c55e' }}
      >
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
          <path
            d="M10 22L18 30L34 14"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <p className="mt-4 text-white font-bold text-lg">{t('successOverlay.saved')}</p>

      {/* Potential coins badge */}
      {displayCoins != null ? (
        <div className="mt-3 flex flex-col items-center gap-1">
          <div
            className="px-5 py-2.5 rounded-2xl font-bold text-base text-white"
            style={{ background: 'rgba(251,191,36,0.25)', border: '1px solid rgba(251,191,36,0.5)' }}
          >
            {t('successOverlay.potentialCoins', { coins: displayCoins })}
          </div>
          <p className="text-xs font-medium" style={{ color: 'rgba(251,191,36,0.8)' }}>
            {t('successOverlay.pendingApproval')}
          </p>
        </div>
      ) : (
        <p className="mt-3 text-white text-sm opacity-70 font-medium">
          {t('successOverlay.noReward')}
        </p>
      )}
    </div>
  )
}
